// <div data-controller="writer--primary-colors">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import * as helpers from "@/utils/helpers";

export default class extends Controller {
  static targets = ["textColor", "backgroundColor", "previewButton", "warning"]

  connect() {
    // 기본값 (input에 값이 없을 경우 미리보기용으로만 사용)
    this.defaultTextColor = "#000000";      // 검은색
    this.defaultBackgroundColor = "#ffffff";  // 흰색

    // 페이지 로드 시 미리보기 버튼 업데이트
    this.updateColors();
  }

  updateColors() {
    let textColor = this.textColorTarget.value;
    let bgColor = this.backgroundColorTarget.value;

    // 사용자가 선택하지 않은 경우 기본값 사용 (input에 기본값을 세팅하지 않음)
    if (!textColor) { textColor = this.defaultTextColor; }
    if (!bgColor) { bgColor = this.defaultBackgroundColor; }

    // 버튼 색상 업데이트
    this.previewButtonTarget.style.color = textColor;
    this.previewButtonTarget.style.backgroundColor = bgColor;

    // 색상 대비 체크: 대비가 낮으면 경고 텍스트 보이기
    if (this.hasPoorContrast(textColor, bgColor)) {
      this.warningTarget.classList.remove("hidden");
    } else {
      this.warningTarget.classList.add("hidden");
    }
  }

  applyPalette(event) {
    const button = event.currentTarget;
    const presetTextColor = button.dataset.colorText;
    const presetBgColor = button.dataset.colorBg;

    // 프리셋 값을 각 color_field에 할당
    this.textColorTarget.value = presetTextColor;
    this.backgroundColorTarget.value = presetBgColor;

    this.updateColors();
  }

  // 색상 대비를 평가하는 메서드 (간단한 접근법: WCAG 대비 비율 기준을 활용)
  hasPoorContrast(textColor, bgColor) {
    const toRgb = (hex) => {
      hex = hex.replace("#", "");
      if (hex.length === 3) {
        hex = hex.split("").map(c => c + c).join("");
      }
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return { r, g, b };
    };

    const luminance = (rgb) => {
      const a = [rgb.r, rgb.g, rgb.b].map((v) => {
        v /= 255;
        return (v <= 0.03928) ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
    };

    const rgbText = toRgb(textColor);
    const rgbBg = toRgb(bgColor);

    const L1 = luminance(rgbText);
    const L2 = luminance(rgbBg);
    const contrastRatio = (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);

    // 예시 기준: 대비 비율이 4 미만이면 경고 (필요에 따라 기준을 조절하세요)
    return contrastRatio < 4;
  }
}
